module.exports = __webpack_public_path__ + "img/naranja.1f81a3e3.svg";